import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { Link } from 'foundations-components/transitional/components/Link';
import PortalIdParser from 'PortalIdParser';
import { useCallback, useMemo } from 'react';
import { getFromFieldValidationMessage, getSelectOptionsFromEmails } from '../../utils/email';
import { trackInteraction } from '../../usage-tracker/track';
import { useEmailShareTabContext } from '../../context/EmailShareTabContext';
import { jsx as _jsx } from "react/jsx-runtime";
const EMAIL_SETTINGS_URL = `/settings/${PortalIdParser.get()}/user-preferences/email`;
export const FromField = ({
  emailSettingsConfig
}) => {
  const {
    connectedEmails,
    connectedEmailsLoading,
    selectedFromValue,
    updateSelectedFromValue,
    emailSettings
  } = useEmailShareTabContext();
  const fromFieldSelectOptions = useMemo(() => getSelectOptionsFromEmails(connectedEmails), [connectedEmails]);
  const handleChange = useCallback(event => {
    const fromValue = connectedEmails.find(({
      email
    }) => email === event.target.value);
    updateSelectedFromValue(fromValue);
  }, [connectedEmails, updateSelectedFromValue]);
  const validationMessage = getFromFieldValidationMessage(selectedFromValue);
  const readOnly = selectedFromValue.email === emailSettings.defaultFromEmail && !selectedFromValue.disabled && !emailSettings.canSendFromOtherEmails;
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.fromField.label"
    }),
    error: !!validationMessage,
    validationMessage: validationMessage,
    labelTooltip: readOnly && (emailSettingsConfig === null || emailSettingsConfig === void 0 ? void 0 : emailSettingsConfig.canSendFromOtherEmailsDisabledTooltip),
    children: /*#__PURE__*/_jsx(UISelect, {
      "data-test-id": "email-share-tab-from-field",
      onChange: handleChange,
      isLoading: connectedEmailsLoading,
      disabled: connectedEmailsLoading,
      options: fromFieldSelectOptions,
      value: selectedFromValue.email,
      readOnly: readOnly,
      dropdownFooter: /*#__PURE__*/_jsx(Link, {
        href: EMAIL_SETTINGS_URL,
        external: true,
        onClick: () => {
          trackInteraction({
            action: 'click Manage HubSpot connected emails link'
          });
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CommerceToolsUiLib.shareToolModal.emailTab.fromField.helper"
        })
      })
    })
  });
};